'use strict';

const $ = require('jquery');
const messages = document.querySelectorAll('.js-international-withdrawal-fee');
const input = document.querySelector('.js-international-withdrawal-currency');
const DEFAULT_KEY = 'default-fee';

const defaultMessages = [ ...messages ]
	.filter(element =>
		data(element, 'currency') === DEFAULT_KEY);

const test = currency =>
	input && input.value === currency;

const testAll = () =>
	[ ...messages ].filter(message =>
		test(data(message, 'currency')));

const render = () => {
	const matches = testAll();
	hide(messages);
	show(matches);

	if(matches.length === 0) {
		show(defaultMessages);
	}
};

if(input && messages) {
	render();
	input.addEventListener('change', render);
}

function show(elements) {
	[ ...elements ]
		.forEach(element => {
			element.style.display = 'block';
			element.setAttribute('aria-hidden', false);
		});
}

function hide(elements) {
	[ ...elements ]
		.forEach(element => {
			element.style.display = 'none';
			element.setAttribute('aria-hidden', true);
		});
}

function data(element, key) {
	return $(element).data(key);
}